/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { JasperReportType } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * ReportService - axios parameter creator
 * @export
 */
export const ReportServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Reporttypen
         * @summary Report-Typen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/jasper-print/report-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportService - functional programming interface
 * @export
 */
export const ReportServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Reporttypen
         * @summary Report-Typen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JasperReportType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportService - factory interface
 * @export
 */
export const ReportServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Reporttypen
         * @summary Report-Typen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTypes(options?: any): AxiosPromise<Array<JasperReportType>> {
            return localVarFp.getReportTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportService - interface
 * @export
 * @interface ReportService
 */
export interface ReportServiceInterface {
    /**
     * Liefert eine Liste von Reporttypen
     * @summary Report-Typen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceInterface
     */
    getReportTypes(options?: any): AxiosPromise<Array<JasperReportType>>;

}

/**
 * ReportService - object-oriented interface
 * @export
 * @class ReportService
 * @extends {BaseAPI}
 */
export class ReportService extends BaseAPI implements ReportServiceInterface {
    /**
     * Liefert eine Liste von Reporttypen
     * @summary Report-Typen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportService
     */
    public getReportTypes(options?: any) {
        return ReportServiceFp(this.configuration).getReportTypes(options).then((request) => request(this.axios, this.basePath));
    }
}
